import {
  selectAllInstallations,
  fetchAllInstallations,
} from "features/admin/Installations/installationAdminSlice";
import {
  getInstallationPrice,
  getInstallationPriceEur,
  getProductWithInstallationPrice,
} from "features/cart/utils";
import { Product } from "features/ProductReel/types";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

export const useInstallation = (power_btu: string, type: string) => {
  const dispatch = useDispatch();
  const installations = useSelector(selectAllInstallations);
  if (power_btu) {
    var installationPrice = getInstallationPrice(power_btu, installations, type);
    var installationPriceEur = getInstallationPriceEur(
      power_btu,
      installations,
      type
    );
  }
  useEffect(() => {
    installations.length === 0 && dispatch(fetchAllInstallations());
  }, [dispatch]);

  const applyInstallation = (product: Product, hasInstallation: boolean) => {
    return getProductWithInstallationPrice(
      product,
      hasInstallation,
      installations,
      type
    );
  };

  return {
    installationPrice: installationPrice ?? 0,
    installationPriceEur: installationPriceEur ?? 0,
    applyInstallation,
  };
};
